/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Biochemie_Chemie_Pharma24Inputs */

const en__field_enum_mzs_biochemie_chemie_pharma24 = /** @type {(inputs: _Field_Enum_Mzs_Biochemie_Chemie_Pharma24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`biochemisty, chemisty, pharmacy`)
};

const de__field_enum_mzs_biochemie_chemie_pharma24 = /** @type {(inputs: _Field_Enum_Mzs_Biochemie_Chemie_Pharma24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biochemie, Chemie und Pharmazie`)
};

/**
* | output |
* | --- |
* | "biochemisty, chemisty, pharmacy" |
*
* @param {_Field_Enum_Mzs_Biochemie_Chemie_Pharma24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_biochemie_chemie_pharma24 = /** @type {((inputs?: _Field_Enum_Mzs_Biochemie_Chemie_Pharma24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Biochemie_Chemie_Pharma24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_biochemie_chemie_pharma24(inputs)
	return de__field_enum_mzs_biochemie_chemie_pharma24(inputs)
});
export { _field_enum_mzs_biochemie_chemie_pharma24 as "_field_enum_MZS_BIOCHEMIE_CHEMIE_PHARMA" }